import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import PlaneSend from '@/assets/icons/plane-send.svg';
import { ExternalLinkIcon } from '@/components/icons/external-link';
import { Button } from '@/components/ui/button';
import { useHireUrl } from '@/hooks/use-hire-url';

const REACH_SUPPORT_URL =
  'https://support.fountain.com/en/articles/9899478-fountain-reach';

interface CardButtonProps {
  channel: string;
  openingId?: string;
}

export function CardButton({ channel, openingId }: CardButtonProps) {
  const { getHireSourcingUrl } = useHireUrl();

  switch (channel) {
    case 'indeed':
    case 'boost':
    case 'spring':
      return (
        <Button variant="secondary" asChild>
          <Link to={getHireSourcingUrl(channel, openingId)} target="_blank">
            <img src={PlaneSend} alt="Start" />
            <FormattedMessage defaultMessage="Post Job" />
          </Link>
        </Button>
      );
    case 'reach':
      return (
        <Button variant="secondary" asChild>
          <Link to={REACH_SUPPORT_URL} target="_blank">
            <ExternalLinkIcon className="text-fx-primary" />
            <FormattedMessage defaultMessage="Learn More" />
          </Link>
        </Button>
      );
    case 'joveo':
      return (
        <Button variant="secondary" disabled>
          <FormattedMessage defaultMessage="Coming soon..." />
        </Button>
      );
    default:
      return null;
  }
}
